import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Divider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import theme from '../../theme';
import { styles } from './modal.styles';
export const ModalComponent = (props)=>{
    const { modalFooter, modalHeader, modalContent, size, isOpen, handleClose, showCloseIcon, width, className } = props;
    const classes = styles();
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs(Modal, {
            maxHeight: "75vh",
            size: size,
            blockScrollOnMount: false,
            isOpen: isOpen,
            onClose: handleClose,
            isCentered: true,
            children: [
                /*#__PURE__*/ _jsx(ModalOverlay, {}),
                /*#__PURE__*/ _jsxs(ModalContent, {
                    className: className,
                    maxW: width ? width : '56rem',
                    children: [
                        /*#__PURE__*/ _jsx(ModalHeader, {
                            margin: 3,
                            sx: classes.title,
                            children: modalHeader
                        }),
                        showCloseIcon && /*#__PURE__*/ _jsx(ModalCloseButton, {
                            sx: classes.closeIcon
                        }),
                        /*#__PURE__*/ _jsx(ModalBody, {
                            children: modalContent
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            color: theme.colors.foundation[100]
                        }),
                        /*#__PURE__*/ _jsx(ModalFooter, {
                            margin: 3,
                            children: modalFooter
                        })
                    ]
                })
            ]
        })
    });
};
ModalComponent.displayName = 'ModalComponent';
